import { Box, styled } from "@mui/system";

export const AddItemContainer = styled(Box)({
  position: 'relative',
  marginRight: '30px'
});

export const AddItemOptionsContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  fontSize: '11px',
  fontWeight: 400,
  color: '#000',
  boxShadow: '0px 1px 4px 0px #00000040',
  padding: '11px 0',
  minWidth: '155px',
  position: 'absolute',
  background: '#fff',
  zIndex: 5,
  marginTop: '2px',
});

export const AddItemOption = styled(Box)({
  cursor: 'pointer',
  padding: '5px 16px',
  '&:hover': {
    background: '#EFF5F8'
  },
});

export const MultiFieldContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

export const StatusContainer = styled(Box)({
  display: 'flex',
  // flexDirection: 'column',
  marginBottom: '15px',
});

export const StatusItem = styled(Box)({
  display: 'flex',
  marginRight: '15px',
  alignItems: 'center',
});

export const StatusIcon = styled(Box)({
  marginRight: '5px',
});

export const StatusTitle = styled(Box)({
  color: '#999999',
  marginRight: '5px'
});

export const StatusValue = styled(Box)({
  color: '#333333',
  fontWeight: 'bold',
});